import React, { useState } from 'react'
import { HeaderHome } from '../HeaderHome/HeaderHome'
import { ListPostulation } from '../../UI/ListPostulation/ListPostulation'

export const Postulation = () => {
  const [ reload, setReload ] = useState(false)
  const onReload = () => setReload((prevState) => !prevState)

  const [data, setData] = useState("");

  const catchValue = (valueHeaderHome) => {
    setData(valueHeaderHome);
  };

  return (
    <div className='viewPostulation'>
      <HeaderHome sendValue={catchValue}></HeaderHome>
      <div className="containPostulation"> 
          
        <div className='peoplePostulated'>
          <h2>Mis Postulaciones   </h2>
          <div className='containCardPost'>
            <ListPostulation datos={data} worksActive={true} reload={reload} onReload={onReload} />
          </div>
        </div>
      </div>
    </div>
  )
}